import { Country, SearchModes } from '@/domainLogic/index.ts';
import type { ConfigValuesApp } from '@/app/common/config/configuration/configurationTypes.ts';

type AreTaxesIncludedInPriceProps = {
  searchMode: string;
  country: Country;
  configValuesApp?: ConfigValuesApp;
};
export const areTaxesIncludedInPrice = ({ searchMode, configValuesApp, country }: AreTaxesIncludedInPriceProps) =>
  configValuesApp?.taxesIncludedInPrice ||
  configValuesApp?.taxesIncludedPopup ||
  (searchMode === SearchModes.HO && country === Country.GB);
